import CreateFloatingClientLicenseFile from '../../CreateFloatingClientLicenseFile'
import CreateComputeServerClientLicense from '../../CreateComputeServerClientLicense'
import CreateClusterManagerClientLicense from '../../CreateClusterManagerClientLicense'
import { createDescriptor, PageDescriptor } from '../../types'
import CopyCloudLicenseFile from './CopyCloudLicenseFile'
import CopyWLSLicenseFile from './CopyWLSLicenseFile'

export function *getNonLocalLicenses(license: string|null, isContainer: boolean, os: string): Generator<PageDescriptor> {
    switch(license)
    {
        case 'tsclient':
            yield createDescriptor(CreateFloatingClientLicenseFile, { os, isContainer })
            break
        case 'csclient':
            yield createDescriptor(CreateComputeServerClientLicense, { os, isContainer })
            break
        case 'cmclient':
            yield createDescriptor(CreateClusterManagerClientLicense, { os, isContainer })
            break
        case 'wlssu':
        case 'wlsuu':
            yield createDescriptor(CopyWLSLicenseFile, { os, isContainer })
            break
        case 'ic':
            yield createDescriptor(CopyCloudLicenseFile, { os, isContainer })

    }
}